// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_AOe","cls2":"WorkCard-cls2_o6P WorkCard-cls1_AOe"};